import React, { useMemo } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import * as types from '../../reducer/constants';
import { checkIsDeleteServiceSubscriptionProvider, checkIsDisabledMode, getModeOptions } from './helper';

const FieldMode = ({ modal, form, dispatchServiceData }) => {
  const { mode } = form;
  const selectedValue = mode ? '1' : '0';
  const selectOptions = getModeOptions(modal);
  const isDisabled = checkIsDisabledMode(selectOptions, modal);
  const isDeleteServiceSubscriptionProvider = useMemo(() => checkIsDeleteServiceSubscriptionProvider(modal), [modal]);

  const onChange = (e) => {
    const value = Number(e.target.value);
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_MODE, value });

    /*
      Если сервис был Subscription и ему удалили провайдера, то
      service_type всегда будет = 100 (Subscription)
     */
    if (isDeleteServiceSubscriptionProvider) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SERVICE_TYPE, value: 100 });
    }
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="mode">Mode</ControlLabel>
        <select name="mode" id="mode" className="form-control" value={selectedValue} onChange={onChange} disabled={isDisabled}>
          {selectOptions.map((item) => (
            <option value={item.value} key={item.value}>
              {item.name}
            </option>
          ))}
        </select>
      </FormGroup>
    </>
  );
};

FieldMode.propTypes = {
  modal: PropTypes.object,
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldMode;
